<template>
  <div class="wrapper">
      <!-- 右侧进度条 -->
      <div class="progress-box" v-if="moduleName=='医调研' && showTemplate=='form'">
        <div class="progress-percent">{{Math.round((valueLength/columnLength)*100)}}%</div>
        <div class="progress-line">
          <div class="progress-line-inner" :style="'height:'+ (valueLength/columnLength)*100 +'%'"></div>
        </div>
        <div class="progress-text">进度</div>
      </div>
      <div v-if="cssContent" v-html="unexcapeHtml(cssContent)"></div>
      <div class="content-wrapper form-wrapper" id="formApp" v-cloak>

          <!-- 未登录 -->
          <!-- <div class="form-tip phone-tran" v-if="showTemplate==='login'">
              <img src="https://img.medsci.cn/web/prod/img/form_error.png" alt="">
              <p>本次调研需要登录</p>
              <el-button type="primary" @click="showLogin">前往登录</el-button>
          </div> -->
          <!-- 请求出错 -->
          <div class="form-tip phone-tran" v-if="showTemplate==='error'">
            <img src="https://img.medsci.cn/web/prod/img/form_error.png" alt="">
            <p>{{userId && userStatus === 'uncomplete' && loginAuthority==3 ?'请先完善信息':(errorMsg?errorMsg:'加载失败，请稍后再试')}}</p>
            <div>
              <el-button @click="backHome" v-if="showBackBtn">返回首页</el-button>
            </div>
        </div>
          <!-- 表单开放时间未到 -->
          <div class="form-start" v-if="showTemplate==='time'">
            <div class="form-not-start" style="padding-bottom: 100px">
                <h2>距离表单开放填写剩余</h2>
                <div class="form-number" id="formStartTime">
                </div>
                <div class="form-time-tip">
                    <span>表单暂未开放，开放时间：</span>
                    <span>{{startTime}}</span>
                </div>
            </div>
          </div>
          <div class="form-mid" v-if="showTemplate==='form'">
              <div class="medsci-form-header">
                  <h2 class="editFont">{{templateName}}</h2>
                  <div v-if="surveyIntroduce" v-html="unexcapeHtml(surveyIntroduce)"></div>
                  <!-- <p>梅斯医学一直致力于学术推广，为临床医生提供专业的学术化服务，为了更好的满足您的临床科研需求，敬请您配 合完成以下问卷，谢谢！ </p> -->
                  <!-- <div v-if="moduleName!='医调研'"> -->
                     <!-- <div style="color: #999" v-if="pageNum > 1">当前：
                      <span v-text="pageIndex" style="color:#3F9EFE">1</span>
                      <span>/</span>
                      <span v-text="pageNum">1</span>
                      <span>页</span>
                    </div> -->
                    <!-- <div class="cut-line"></div> -->
                    <!-- <div class="cut-line" style="background: #EEEBEB;height: 4px;margin: 10px 0 10px;">
                        <div class="cut-line" :style="'width:'+ (valueLength/columnLength)*100 +'%'+';height: 4px;background: #53a4f4;'"></div>
                    </div>
                    <div style="color: #999" v-if="formVersion!=1">
                      <span v-text="valueLength" style="color:#3F9EFE">1</span>
                      <span>/</span>
                      <span v-text="columnLength">1</span>
                      <span>题</span>
                    </div> -->
                  <!-- </div> -->
              </div>
              
                <!-- 表单可填写 -->
              <div class="medsci-form-content" v-if="isOpenResult != 1">
                  <k-form-build ref="KFB" v-if="formVersion===1" :value="jsonData"></k-form-build>
                  <avue-form v-else ref="form" v-model="form" :option="option"></avue-form>
                  <div class="form-page">
                      <div style="text-align: center;" v-if="formVersion===1">
                        <el-button v-if="showSubmit" @click="getOldData" type="primary" :class="submitLoading ? 'submit-disabled' : ''" v-text="submitLoading ? '提交中...' : disabledSubmit?'已提交':'提交'"></el-button>
                        <!-- <el-button @click="backHome" v-if="showBackBtn">返回首页</el-button> -->
                      </div>
                      <div class="form-page-wrapper" v-else style="text-align: center">
                          <el-button v-show="pageIndex > 1" @click="prevPage()" type="primary" class="lastPagee">上一页</el-button>
                          <el-button :disabled='disabledNextPage' v-show="pageIndex < pageNum" @click="nextPage()" type="primary" >下一页</el-button>
                          <el-button style="margin-bottom:10px" @click="storageSave" type="primary" plain v-if="temporarySave===1 && surveyType===1">临时保存</el-button>
                          <!-- <el-button :disabled='disabledNextPage || disabledSubmit || emptyValue' v-show="pageIndex == pageNum" @click="getData" type="primary" :class="submitLoading ? 'submit-disabled' : ''" v-text="submitLoading ? '提交中...' : disabledSubmit?'调研已提交':'提交'"></el-button> -->
                          <el-button v-if="showSubmit" :disabled='disabledSubmit' v-show="pageIndex == pageNum" @click="getData" type="primary" :class="submitLoading ? 'submit-disabled' : ''" v-text="isEnding ? '已过期' : isNotStart == true ? '未开始' : submitLoading ? '提交中...' : disabledSubmit?'已提交':'提交'"></el-button>

                          <!-- <span class="page-font" v-if="pageNum > 1">
                              <span v-text="pageIndex">1</span>
                              <span>/</span>
                              <span v-text="pageNum">1</span>
                              <span>页</span>
                          </span> -->
                      </div>
                  </div>
              </div>
                <!-- 表单可填写 -->
              <div class="medsci-form-content" v-if="isOpenResult == 1">
                  <k-form-build ref="KFB" v-if="formVersion===1" :value="jsonData"></k-form-build>
                  <avue-form v-else ref="form" v-model="form" :option="option"></avue-form>
                  <div class="form-page">
                      <div style="text-align: center;" v-if="formVersion===1">
                        <el-button v-if="showSubmit" @click="getOldData" type="primary" :class="submitLoading ? 'submit-disabled' : ''" v-text="submitLoading ? '提交中...' : disabledSubmit?'已投':'投票'"></el-button>
                        <!-- <el-button @click="backHome" v-if="showBackBtn">返回首页</el-button> -->
                      </div>
                      <div class="form-page-wrapper" v-else style="text-align: center">
                          <el-button v-show="pageIndex > 1" @click="prevPage()" type="primary" class="lastPagee">上一页</el-button>
                          <el-button :disabled='disabledNextPage' v-show="pageIndex < pageNum" @click="nextPage()" type="primary" >下一页</el-button>
                          <el-button @click="storageSave" type="primary" plain v-if="temporarySave===1 && surveyType===1">临时保存</el-button>
                          <!-- <el-button :disabled='disabledNextPage || disabledSubmit || emptyValue' v-show="pageIndex == pageNum" @click="getData" type="primary" :class="submitLoading ? 'submit-disabled' : ''" v-text="submitLoading ? '提交中...' : disabledSubmit?'调研已提交':'提交'"></el-button> -->
                          <el-button v-if="showSubmit" :disabled='disabledSubmit' v-show="pageIndex == pageNum" @click="getData" type="primary" :class="submitLoading ? 'submit-disabled' : ''" v-text="isEnding ? '已过期' : isNotStart == true ? '未开始' : submitLoading ? '提交中...' : disabledSubmit?'已投':'投票'"></el-button>

                          <!-- <span class="page-font" v-if="pageNum > 1">
                              <span v-text="pageIndex">1</span>
                              <span>/</span>
                              <span v-text="pageNum">1</span>
                              <span>页</span>
                          </span> -->
                      </div>
                  </div>
              </div>
          </div>

          <!-- 表单结果页面 -->
          <!-- <div class="form-tip phone-tran" v-if="showTemplate==='success' && commitShow">
              <img src="https://img.medsci.cn/web/prod/img/form-success.png" alt="" class="s-img">
              <p class="sp" style="margin-left: 0">提交成功，感谢您的参与</p>
              <div class="form-page-wrapper">
                <el-button v-if="isOpenResult===1 && !objectType" @click="showResult" type="primary">数据统计</el-button>
                <el-button @click="backHome" class="button" v-if="showBackBtn">返回首页</el-button>
              </div>
              <p v-if="isOpenResult===1 && !objectType" style="font-size: 14px;color: #999;font-weight: normal;">当前为实时统计数据，最终数据请在调研结束后查看</p>
          </div> -->
          
          <!-- 统计页面 -->
          <div class="form-result newResult" v-if="showTemplate==='result'">
            <div class="medsci-form-header">
                <h2 class="editFont">{{templateName}}</h2>
                <!-- <div class="result-grey">我们将为您的投票保密</div> -->
                <div v-if="surveyIntroduce" v-html="unexcapeHtml(surveyIntroduce)"></div>
                <!-- <div class="cut-line"></div> -->
            </div>

            <div class="medsci-form-content">
                <div id="formResult">
                  <div v-if="resultList.length && isEnd">
                     <div class="res-item" v-for="(item, index) in resultList" :key="index">
                        <!-- <div class="item-label">{{index+1}}、{{item.label}}</div> -->
                        <div class="item-label">{{item.label}}</div>
                        <div class="item-list">
                            <div class="list-options" v-for="(row, n) in item.optionStatistics" :key="n">
                                <div class="item-list-pre">
                                    <div class="pre-bottom" :class="row.currentUser == 1?'current':''" :style="'width:'+ (row.proportion?row.proportion:3.3) +'%'">
                                      <div class="percent-font" >{{row.proportion}}%</div>
                                      <div class="item-list-label">{{row.label}}</div>
                                    </div>
                                    <!-- <div class="percent" :style="'width:'+ row.proportion +'%'"></div> -->
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style="text-align: center;">
                      <el-button type="primary widthBtn" disabled v-text="isEnding ? '已过期' : '已投'"></el-button>
                      <!-- <el-button @click="backHome" class="button" v-if="showBackBtn">返回首页</el-button> -->
                    </div>
                  </div>
                  <div v-else-if="resultList.length && !isEnd">
                     <div class="res-item" v-for="(item, index) in resultList" :key="index">
                        <!-- <div class="item-label">{{index+1}}、{{item.label}}</div> -->
                        <div class="item-label">{{item.label}}</div>
                        <div class="item-list">
                            <div class="list-options" v-for="(row, n) in item.optionStatistics" :key="n">
                                <div class="item-list-pre">
                                    <div class="pre-bottom widthBtns" :class="row.currentUser == 1?'current':''">
                                      <!-- <div class="percent-font" >{{row.proportion}}%</div> -->
                                      <div class="item-list-label item-lable-new">{{row.label}}</div>
                                    </div>
                                    <!-- <div class="percent" :style="'width:'+ row.proportion +'%'"></div> -->
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style="text-align: center;">
                      <el-button type="primary widthBtn" disabled v-text="isEnding ? '已过期' : '已投'"></el-button>
                      <!-- <el-button @click="backHome" class="button" v-if="showBackBtn">返回首页</el-button> -->
                    </div>
                  </div>
                  <div class="form-tip phone-tran" v-else>
                      <img src="https://img.medsci.cn/web/prod/img/form_error.png" alt="">
                      <p>暂无数据</p>
                      <div style="text-align: center;">
                        <el-button type="primary widthBtn" disabled v-text="isEnding ? '已过期' : '已投'"></el-button>
                        <!-- <el-button @click="backHome" class="button" v-if="showBackBtn">返回首页</el-button> -->
                      </div>
                  </div>  
                </div>
            </div>
            
          </div>
      </div>
      <!-- END .wrapper -->
  </div>
</template>

<script>
// import { Toast } from 'vant';
  var baseUrl,ajaxUrl
  checkEnv()
  function checkEnv() {
    const ipCheck = /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/
    if(window.location.href.includes('localhost') || ipCheck.test(window.location.hostname)) {
      baseUrl = 'https://portal-test.medon.com.cn'
      ajaxUrl = 'https://apigateway.medon.com.cn'
      // ajaxUrl = 'https://apigateway.medsci.cn'
      // ajaxUrl = 'https://medsci-gateway.medon.com.cn'
    } else if(window.location.href.includes('test') || window.location.href.includes('medon')){
      baseUrl = 'https://portal-test.medon.com.cn'
      ajaxUrl = 'https://apigateway.medon.com.cn'
      // ajaxUrl = 'https://medsci-gateway.medon.com.cn'
    } else {
      if(window.location.host == 'www.medsci.cn') {
        baseUrl = 'https://www.medsci.cn'
      }else {
        baseUrl = 'https://apigateway.medsci.cn/web/medsci'
      }
      ajaxUrl = 'https://apigateway.medsci.cn'
    }
}

var userStatus = window.localStorage.getItem('userStatus') ?  window.localStorage.getItem('userStatus') : 'complete'
getUserStatus()
function getUserStatus() {
    jQuery.ajax({
        type: 'get',
        url: `${baseUrl}/perfectInfo/userInfoStatus`,
        contentType: "application/json",
        dataType: 'json',
        async:false,
        success: function (result) {
            if (result.status == 200 && result.message == "success") {//成功
                if (result.data.isCompleteInfo === 0) {
                    userStatus = 'uncomplete'
                    window.localStorage.setItem('userStatus', 'uncomplete')
                } else {
                    userStatus = 'complete'
                    window.localStorage.setItem('userStatus', 'complete')
                }
            }
        },
        error: function (result) {// 请求报错执行
            console.log(result)
        }
    });
}
const unescapeMap = {
  '&amp;': '&',
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  "&#x27;": "'",
  '&#x60;': '`',
  '&ldquo;': '“',
  '&rdquo;': '”',
  '&lsquo;': '‘',
  '&rsquo;': '’',
  '&middot;': '·',
  '&nbsp;': ' ',
  '&hellip;': '…'
}

import jQuery from 'jquery'
export default {
  name: "ms-form",
  data() {
    return {
      isNotStart:'',
      isEnding:'',
      isshowTp:'',
      commitShow:true,
      shareCopyWriting:'',
      isEnd: true,
      surveyIntroduce:'',
      pollResults:1,
      openEndTime:'',
      openStartTime:'',
      submitLoading: false,
      pageIndex: 1,
      pageSize: 9,
      pageNum: 1,
      total: 0,
      formPageData: [],
      option: {},
      form: {},
      templateName: '',
      showTemplate: '',
      startTime: '',
      resultList: [],
      formVersion: null,
      jsonData: {},
      errorMsg: '',
      encodeId: '',
      userId: '',
      userName: '',
      account: '',
      accountType: '',
      templateId: '',
      projectName: '',
      moduleName: '',
      projectId: '',
      objectId: '',
      objectType: null,
      isOpenResult: null,  //0 问卷  1 投票
      disabledNextPage: false,
      cssContent: '',
      valueLength: 0,
      columnLength: 1,
      disabledSubmit: false,
      emptyValue: true,
      allList: [],
      titleLength: 0,
      loginAuthority: null,
      // isPerfectInfo: null,
      wordReactUrl: '', //跳转地址
      wordReactText: '', //跳转提示
      temporarySave: null, //临时保存
      beginTime: null,
      endTime: null,
      surveyType: 1, // 0 - 医迅达和直播， 1-调研等 
      requiredArr: [],
      userStatus,
      showSubmit: true,
      source: 1, //区分来源 1主站 2生物谷
      tenantProjectId: null,
    }
  },
  props: {
    loginType: String,
    tableInfo: Object,
    config: Object,
    showBackBtn: {
      type: Boolean,
      default: false
    },
  },
  watch: {
    tableInfo: {
      handler: function() {
        if(this.tableInfo.encodeId) {
          this.initData()
          this.init()
          this.computeTime()
          if(this.surveyType == 1) {
            this.pvCount()
            if(this.userId) {
              this.uvCount()
            }
          }
          this.dealScript()
          this.oldOption = this.deepCopy(this.option)
          // this.$nextTick(()=>{
          //   this.resetArrange()
          // })
          let _this = this
          setTimeout(function(){
            _this.resetArrange()
          },10)
          console.log('更新2022-6-6/14:00')
        }else {
          this.showTemplate = 'error'
        }
      },
      deep: true,
      immediate: true
    },
    form:{
      handler: function(val) {
        this.$nextTick(()=>{
          if(this.showTemplate == 'form' && this.formVersion !== 1) {
            this.checkData()
          }
          this.resetArrange()
        })
        if(this.option.column) {
          this.option.column.forEach(item=>{
            // 题目关联
            let showTopic
            let arr = item.correlation?item.correlation.filter(item => !!item.prop && !!item.value.length):[]
            if(arr && arr.length) {
              // 关联且
              if(item.relationship === 'and') {
                showTopic = arr.every(n=>{
                  if(Object.prototype.toString.call(val[n.prop]) === '[object Array]') {
                    return val[n.prop].length && n.value.some(m=>{return val[n.prop].indexOf(m)!=-1})
                  }else {
                    return n.value.includes(val[n.prop])
                  }
                })
              }
              // 关联或
              if(item.relationship === 'or') {
                showTopic = arr.some(n=>{
                  if(Object.prototype.toString.call(val[n.prop]) === '[object Array]') {
                    return val[n.prop].length && n.value.some(m=>{return val[n.prop].indexOf(m)!=-1})
                  }else {
                    return n.value.includes(val[n.prop])
                  }
                })
              }
              this.findObject(this.option.column, item.prop).display = showTopic
              this.findObject(this.oldOption.column, item.prop).display = showTopic
              // if(item.display === false && typeof item.display === 'boolean'){
              //   if(this.form[`$${item.prop}`]) {
              //     this.form[`$${item.prop}`]=''
              //   }
              //   if(this.form[`${item.prop}`]) {
              //     this.form[`${item.prop}`]=''
              //   }
              // }
            }
          })
        }
      },
      deep: true,
      immediate: true
    },
  },
  mounted() {
    console.log(this.getRandomUser(),'this.getRandomUser()');
    
    console.log(this.isEnd,'ised');
      // this.initData()
      // this.init()
  },
  methods: {
      initData() {
        this.encodeId = this.tableInfo.encodeId
        this.userId = this.tableInfo.userId ? this.tableInfo.userId :''
        this.userName = this.tableInfo.userName ? this.tableInfo.userName : ''
        this.account = this.tableInfo.account ? this.tableInfo.account : ''
        this.projectId = Number(this.tableInfo.projectId)
        this.projectName = this.tableInfo.projectName ? this.tableInfo.projectName : ''
        this.moduleName = this.tableInfo.moduleName ? this.tableInfo.moduleName : ''
        this.objectId = this.tableInfo.objectId? String(this.tableInfo.objectId):''
        this.objectType = this.tableInfo.objectType? Number(this.tableInfo.objectType):null
        this.surveyType = this.moduleName == '医讯达' ||  this.moduleName == '直播' ? 0 : 1
        this.source = this.tableInfo.source ? this.tableInfo.source : 1
        this.tenantProjectId = this.tableInfo.tenantProjectId ? this.tableInfo.tenantProjectId : null
        this.accountType = typeof(this.tableInfo.accountType)!='undefined' ? this.tableInfo.accountType : ''
        if(this.getQueryVariable('type') == 'preview') {
          this.encodeId = this.getQueryVariable('id')
          this.userId = this.getQueryVariable('userId')
          this.userName = this.getQueryVariable('userName')
          this.account = this.getQueryVariable('account')
        }
      },
      getQueryVariable(variable) {
        var query = window.location.search.substring(1);
        var vars = query.split("&");
        for (var i = 0; i < vars.length; i++) {
          var pair = vars[i].split("=");
          if (pair[0] == variable) {
            return pair[1];
          }
        }
        return false;
      },
      // 处理html片段中的script标签
      dealScript() {
        if(!this.cssContent) {
          return
        }
        let regJs = ''
        this.cssContent.replace(/<script.*?>([\s\S]+?)<\/script>/img, (_, js) => { // 正则匹配出script中的内容
          regJs = js
        })
        this.$nextTick(() => {
          let script = document.createElement('script');
          script.innerHTML = regJs
          document.getElementsByTagName('head')[0].appendChild(script);
        })
      },
      evalFun(val) {
        let json = val
        if(json.column && json.column.length) {
              json.column.forEach(item => {
                if (item.pattern) {
                    const json1 = item.rules.find(j => j.pattern)
                    if (json1) {
                        item.rules.find(j => j.pattern)['pattern'] = item.pattern
                    }
                }
                if(item.change) {
                    item.change = eval(item.change)
                }
                if(item.click) {
                    item.click = eval(item.click)
                }
                if(item.focus) {
                    item.focus = eval(item.focus)
                }
                if(item.blur) {
                    item.blur = eval(item.blur)
                }
                if(item['rules'] && item['rules'].length){
                  item['rules'].forEach((row,index)=>{
                    if(typeof(row) == 'string' && row.includes('validator')) {
                      item['rules'][index] = {validator: eval(row)} 
                    }
                  })
                }
              })
            }
            if(json.group && json.group.length) {
              json.group.forEach(row => {
                if(row.column && row.column.length) {
                  row.column.forEach(item => {
                    if(item.change) {
                        item.change = eval(item.change)
                      }
                      if(item.click) {
                          item.click = eval(item.click)
                      }
                      if(item.focus) {
                          item.focus = eval(item.focus)
                      }
                      if(item.blur) {
                          item.blur = eval(item.blur)
                      }
                      if(item['rules'] && item['rules'].length){
                        item['rules'].forEach((row,index)=>{
                          if(typeof(row) == 'string' && row.includes('validator')) {
                            item['rules'][index] = {validator: eval(row)} 
                          }
                        })
                      }
                  })
                }
              })
            }
          return json
      },
      deepCopy(obj) {
        var newobj = obj.constructor === Array ? [] : {};
        if (typeof obj !== 'object') {
          return obj;
        } else {
        for (var i in obj) {
          if (typeof obj[i] === 'object'){ //判断对象的这条属性是否为对象
            newobj[i] = this.deepCopy(obj[i]);  //若是对象进行嵌套调用
          }else{
              newobj[i] = obj[i];
              }
          }
          }
          return newobj; //返回深度克隆后的对象
      },
      popStatus(loginAuthority, disparkState) {
        if(this.getQueryVariable('type') == 'preview') {
          return
        }
        // if((!this.userId && disparkState && disparkState!=1) || (!this.userId && isLogin==1 && (disparkState==1 || !disparkState))) {
        //   // this.showTemplate = 'login'
        //   // return
        //   this.showLogin()
        // }
        // if(this.userId && this.userStatus === 'uncomplete' && isPerfectInfo == 1 && isLogin == 1) {
        //   window.addPerfectInfoDom()
        // }
        //触发登录弹框 1.没有信息 非开放  2.没有信息 参与权限是 登录或完善信息 开放
        if((!this.userId && disparkState && disparkState!=1) || (!this.userId && (loginAuthority==2 || loginAuthority==3)  && (disparkState==1 || !disparkState))) {
          // this.showTemplate = 'login'
          // return
          this.showLogin()
        }
        //触发完善信息弹框 1.有用户信息 但未完善信息 参与权限是 完善信息
        if(this.userId && this.userStatus === 'uncomplete' && loginAuthority==3) {
          window.addPerfectInfoDom()
        }
      },
      init(){
        let params = {
          id: this.encodeId,
          userId: this.userId,
          userName: this.userName,
          account: this.account,
          projectId: this.projectId,
          objectId: this.objectId,
          objectType: this.objectType,
          source: this.source,
          userAgent: this.getRandomUser(),
          accountType: this.accountType,
          randomOption: true
        }
        let that = this
        let url
        // if(this.account == 'eda') {
        //   url = 'getEdaSurveyDetail'
        // }else {
          url = 'getSurveyDetail'
        // }
        jQuery.ajax({
              type: 'post',
              url: `${ajaxUrl}/api/material/customForm/${url}`,
              //data: params,
              data: JSON.stringify(params),
              contentType:"application/json",
              dataType:'json',
              async:false,
              success: function (result) { // 请求成功执行
                console.log(11111111);
                  that.$emit('sendmsg',result.data)
                  // that.isOpenResult = result.data.isOpenResult
                  // that.surveyIntroduce = result.data.surveyIntroduce
                  that.openStartTime = result.data?result.data.openStartTime:''
                  that.openEndTime = result.data?result.data.openEndTime:''
                  let endTime = new Date(that.openEndTime).getTime();
                  let startTime = new Date(that.openStartTime).getTime();
                  let newdate = new Date().getTime();
                  that.isEnding = newdate > endTime ? true : false
                  that.isNotStart = newdate < startTime ? true : false
                  that.pollResults = result.data? result.data.pollResults: 1
                  that.submitLoading = false;
                  // that.popStatus(result.data?result.data.isLogin:0, result.data?result.data.isPerfectInfo:0,result.data?result.data.disparkState:1)
                  that.popStatus(result.data?result.data.loginAuthority:1,result.data?result.data.disparkState:1)
                  that.loginAuthority = result.data?result.data.loginAuthority:1
                  // that.isPerfectInfo = result.data?result.data.isPerfectInfo:0
                  if(result.status==200 || result.status==112){//成功
                    if(result.status==112){
                      that.isNotStart = true
                      that.disabledSubmit = true
                    }else{
                      that.isNotStart = false
                    }
                    that.showTemplate = 'form'
                    that.openStartTime = result.data.openStartTime
                    that.templateName = result.data.templateName
                    that.shareCopyWriting = result.data.shareCopyWriting
                    // that.$emit('sendName',that.templateName)
                    that.templateId = result.data.templateId
                    that.formData = result.data.templateContent.formContent
                    that.pageSize = result.data.isPage
                    that.formVersion = result.data.templateContent.formVersion
                    that.isOpenResult = result.data.isOpenResult
                    that.cssContent = result.data.cssContent
                    that.surveyIntroduce = result.data.surveyIntroduce
                    that.pollResults = result.data.pollResults
                    that.openEndTime = result.data.openEndTime
                    that.wordReactUrl = result.data.wordReactUrl
                    that.wordReactText = result.data.wordReactText
                    that.temporarySave = result.data.temporarySave
                    if(that.formVersion === 1) {
                      that.jsonData = result.data.templateContent.formContent
                    }else {
                      let json = result.data.templateContent.formContent ? result.data.templateContent.formContent : {}
                      that.option = that.evalFun(json)
                      that.option.emptyBtn = false
                      that.option.submitBtn = false
                      that.$set(that.option, 'readonly', that.config && that.config.readonly ? true : false)
                      that.$set(that.option, 'disabled', that.config && that.config.disabled ? true : false)
                      if(that.config && that.config.disabled) {
                        that.showSubmit = false
                      }
                      // 处理上传
                      that.$axios = window.axios
                      that.option.column.forEach(item => {
                        if (item.type === "upload") {
                          // that.getOssToken()
                          item.uploadBefore = (val, done) => {
                              let renameFile = new File([val],val.uid + val.name,{type:val.type});
                              done(renameFile);
                          };
                          item.uploadAfter = (val, done) => {
                            val.name = val.fileKey
                            val.url = `https://img.medsci.cn/${val.fileKey}`;
                            done();
                          };
                        }
                        // 计算title长度，总数扣除
                        // if(item.type === 'title' && item.display === true && typeof item.display === 'boolean') {
                        //   that.titleLength += 1
                        // }
                      });
                      that.$nextTick(() => {
                        that.initPageData()
                      })
                    }
                    // 回填临时保存
                    if(that.temporarySave === 1) {
                      that.getStorage()
                    }
                  }
                  // else if(result.status==112){
                  //     //未到开放时间
                  //     that.showTemplate = 'form'
                  //     that.startTime = result.message
                  //     let time = new Date(that.startTime).getTime() / 1000
                  //     that.$nextTick(() => {
                  //       that.formTimeSeek(time)
                  //     })
                  // }
                  else if(result.status==113){
                      //调研已结束并公开结果
                      that.templateName = result.data.templateName
                      that.templateId = result.data.templateId
                      // that.showTemplate = 'result'
                      // that.getResult()
                      if(result.data.isOpenResult == 1){
                        if(result.data.pollResults == 1){
                          let endTime = new Date(result.data.openEndTime).getTime();
                          let newdate = new Date().getTime();
                          if(newdate > endTime){
                            that.commitShow = true
                            that.showTemplate = 'result'
                            that.showResult()
                          }else{
                            that.commitShow = false
                            that.isEnd = true
                            that.showTemplate = 'result'
                            that.showResult()
                          }
                          // that.showTemplate = 'result'
                          // that.getResult()
                        }
                        if(result.data.pollResults == 2){
                          let endTime = new Date(result.data.openEndTime).getTime();
                          let newdate = new Date().getTime();
                          if(newdate > endTime){
                            that.commitShow = false
                            that.isEnd = true
                            that.showTemplate = 'result'
                            that.showResult()
                          }else{
                            that.commitShow = false
                            that.isEnd = false
                            that.showResult()

                            // alert(222)
                            // that.getValues()
                            // console.log(that.getValues());
                              //已提交过，投票结果选择投放结束后展示，且投票未结束，回填数据
                            // that.getValues()
                          }
                          // that.showTemplate = 'result'
                          // that.getResult()
                        }
                      }
                  }else if(result.status==114){
                      //已提交过，回填数据
                      that.templateName = result.data.templateName
                      that.templateId = result.data.templateId
                      that.surveyIntroduce = result.data.surveyIntroduce
                      that.formData = result.data.templateContent.formContent
                      that.pageSize = result.data.isPage
                      that.formVersion = result.data.templateContent.formVersion
                      that.isOpenResult = result.data.isOpenResult
                      that.cssContent = result.data.cssContent
                      that.wordReactUrl = result.data.wordReactUrl
                      that.wordReactText = result.data.wordReactText
                      that.temporarySave = result.data.temporarySave
                      that.disabledSubmit = true
                      if(that.formVersion === 1) {
                        that.jsonData = result.data.templateContent.formContent
                      }else {
                        let json = result.data.templateContent.formContent ? result.data.templateContent.formContent : {}
                        that.option = that.evalFun(json)
                        that.option.emptyBtn = false
                        that.option.submitBtn = false
                        that.$set(that.option, 'readonly', that.config && that.config.readonly ? true : false)
                        that.$set(that.option, 'disabled', that.config && that.config.disabled ? true : false)
                        if(that.config && that.config.disabled) {
                          that.showSubmit = false
                        }
                        // 处理上传
                        that.option.column.forEach(item => {
                          if (item.type === "upload") {
                            item.uploadBefore = (val, done) => {
                                let renameFile = new File([val],val.uid + val.name,{type:val.type});
                                done(renameFile);
                            };
                            item.uploadAfter = (val, done) => {
                              val.name = val.fileKey
                              val.url = `https://img.medsci.cn/${val.fileKey}`;
                              done();
                            };
                          }
                          // 计算title长度，总数扣除
                          // if(item.type === 'title' && item.display === true && typeof item.display === 'boolean') {
                          //   that.titleLength += 1
                          // }
                        });
                        that.$nextTick(() => {
                          that.initPageData()
                        })
                      }
                      //投票 展示结果
                      if(that.isOpenResult == 1){
                        if(result.data.isOpenResult == 1){
                        if(result.data.pollResults == 1){
                          let endTime = new Date(result.data.openEndTime).getTime();
                          let newdate = new Date().getTime();
                          if(newdate > endTime){
                            that.commitShow = true
                            that.showTemplate = 'result'
                            that.showResult()
                          }else{
                            that.commitShow = false
                            that.isEnd = true
                            that.showTemplate = 'result'
                            that.showResult()
                          }
                          // that.showTemplate = 'result'
                          // that.getResult()
                        }
                        if(result.data.pollResults == 2){
                          let endTime = new Date(result.data.openEndTime).getTime();
                          let newdate = new Date().getTime();
                          if(newdate > endTime){
                            that.commitShow = false
                            that.isEnd = true
                            that.showTemplate = 'result'
                            that.showResult()
                          }else{
                            that.commitShow = false
                            that.isEnd = false
                            that.showResult()

                            // alert(222)
                            // that.getValues()
                            // console.log(that.getValues());
                              //已提交过，投票结果选择投放结束后展示，且投票未结束，回填数据
                            // that.getValues()
                          }
                          // that.showTemplate = 'result'
                          // that.getResult()
                        }
                      }
                      //问卷 回填数据
                      }else{
                        that.showTemplate = 'form'
                        that.getValues()
                      }
                  }else if(result.status == 100) {
                    that.showTemplate = ''
                  }else {
                    that.showTemplate = 'error'
                    that.errorMsg = result.message
                  }
              }
          });
      },
      // 获取ossToken
      async getOssToken() {
        let axiosUrl = "";
        if (
          window.location.href.includes("test") ||
          window.location.href.includes("localhost") ||
          window.location.href.includes("medon")
        ) {
          axiosUrl =
            "https://apigateway.medon.com.cn/api/mg/information/ossFile/getToken";
        } else {
          axiosUrl =
            "https://apigateway.medsci.cn/api/mg/information/ossFile/getToken";
        }
        jQuery.ajax({
              type: 'post',
              url: axiosUrl,
              data: JSON.stringify({ type: 1 }),
              contentType:"application/json",
              dataType:'json',
              async:false,
              success: function (response) { // 请求成功执行
                if (response.status == 200) {
                  if(window.Vue) {
                    window.Vue.use(window.AVUE, {
                      cos: {
                        Region: "ap-shanghai",
                        SecretId: response.data.accessKeyId,
                        SecretKey: response.data.accessKeySecret,
                        Bucket: response.data.publicBucketName,
                        XCosSecurityToken: response.data.securityToken,
                        timeout: 10 * 1000,
                      },
                    });
                  }else {
                    // eslint-disable-next-line no-undef
                    Vue.use(window.AVUE, {
                      cos: {
                        Region: "ap-shanghai",
                        SecretId: response.data.accessKeyId,
                        SecretKey: response.data.accessKeySecret,
                        Bucket: response.data.publicBucketName,
                        XCosSecurityToken: response.data.securityToken,
                        timeout: 10 * 1000,
                      },
                    });
                  }
                }
              }
          });
      },
      // 回填数据
      getValues() {
        // alert(888888)
          this.submitLoading = true;
          var params = {
              userId: this.userId,
              userName: this.userName,
              id: this.encodeId,
              account: this.account,
              projectId: this.projectId,
              accountType: this.accountType,
              userAgent: this.getRandomUser(),
          }
          var that = this;
          jQuery.ajax({
              type: 'post',
              url: `${ajaxUrl}/api/material/customForm/getSubmitInfo`,
              //data: params,
              data: JSON.stringify(params),
              contentType:"application/json",
              dataType:'json',
              async:false,
              success: function (result) { // 请求成功执行
                  that.submitLoading = false;
                  if(result.status==200){//成功
                    that.form = result.data
                  }else {
                    that.showTemplate = 'error'
                    that.errorMsg = result.message
                  }
              }
          });
      },
      // 初始化单选多选的选项排列
      resetArrange() {
        if(this.option && this.option.column && this.option.column.length) {
          this.option.column.forEach(item=>{
            if(item.arrange) {
              for(let i = 1; i < 11; i++) {
                document.querySelector(`[for=${item.prop}]`).parentNode.classList.remove(`row${i}`)
              }
              document.querySelector(`[for=${item.prop}]`).parentNode.classList.add(item.arrange)
            }
          })
        }
      },
      // 进度条
      checkProgress() {
       
        let arr  = []
        // 获取已填数据数量
        for(let item in this.form) {
          if(!item.includes('$')) {
             this.formData.column.forEach(row=>{
               if(row.display && row.prop == item && row.type != 'title') {
                  if(Object.prototype.toString.call(this.form[item]) === '[object Array]') {
                    if(this.form[item].length > 0) {
                      arr.push(this.form[item])
                    }
                  }else {
                    if(this.form[item]) {
                      arr.push(this.form[item])
                    }
                  }
                }
             })
          }
        }
        // this.valueLength = arr.length - this.titleLength
        this.valueLength = arr.length

        let groupLength = 0
        if(this.formData.group && this.formData.group.length) {
          this.formData.group.forEach(item=>{
            if(item.display) {
              groupLength += item.column.length
            }
          }) 
        }
        let columnLength = 0
        if(this.formData.column && this.formData.column.length) {
          this.formData.column.forEach(item=>{
            if(item.display && item.type != 'title') {
              columnLength += 1
            }
          }) 
        }
        // this.columnLength = columnLength + groupLength - this.titleLength
        this.columnLength = columnLength + groupLength
      },
      checkData() {
        this.checkProgress()
        // 校验必填项
        if(this.pageSize > 0) {
          // 分页
          let indexArr = this.formPageData && this.formPageData.length>0 && this.pageIndex? this.formPageData[this.pageIndex-1] : [] 
          let keyArr = []
          let keys = []
          indexArr.forEach(i=>{
             if(this.allList[i].children) {
              // 子表单
              this.allList[i].children.column.forEach(n=>{
                if(n.required && n.display){
                  let keyF = this.allList[i].prop
                  let key = n.prop
                  keys.push(key)
                  if(this.form[keyF]) {
                    this.form[keyF].forEach(item=>{
                      keyArr.push(item[key])
                    })
                  }
                }
              })
            }else {
              if(this.allList[i].required && this.allList[i].display){
                let key = this.allList[i].prop
                keyArr.push(this.form[key])
                keys.push(key)
              }
            }
          })
          this.requiredArr = keys
          this.disabledNextPage = !keyArr.every(i=>{
            if(Object.prototype.toString.call(i) === '[object Array]') {
              return i && i.length > 0 
            }else {
              return i
            }
          })
          let allArr = this.form?Object.values(this.form):[]
          this.emptyValue = !allArr.some(i=>{
            if(Object.prototype.toString.call(i) === '[object Array]') {
              return i && i.length > 0 
            }else {
              return i
            }
          })
        }else {
          // 未分页
          let keyArr = []
          let keys = []
          // 单个组件
          this.option.column.forEach(i=>{
            if(i.children) {
              // 子表单
              i.children.column.forEach(n=>{
                if(n.required && n.display){
                  let keyF = i.prop
                  let key = n.prop
                  keys.push(key)
                  if(this.form[keyF]) {
                    this.form[keyF].forEach(item=>{
                      keyArr.push(item[key])
                    })
                  }
                }
              })
            }else {
              if(i.required && i.display){
                let key = i.prop
                keyArr.push(this.form[key])
                keys.push(key)
              }
            }
          })
          // 分组
          if(this.option.group && this.option.group.length) {
            this.option.group.forEach(i=>{
              i.column.forEach(n=>{
                 if(n.children) {
                    // 子表单
                    n.children.column.forEach(m=>{
                      if(m.required && m.display){
                        let keyF = n.prop
                        let key = m.prop
                        keys.push(key)
                        if(this.form[keyF]) {
                          this.form[keyF].forEach(item=>{
                            keyArr.push(item[key])
                          })
                        }
                      }
                    })
                  }else {
                    if(n.required && n.display){
                      let key = n.prop
                      keyArr.push(this.form[key])
                      keys.push(key)
                    }
                  }
              })
            })
          }
          this.requiredArr = keys
          this.disabledNextPage = !keyArr.every(i=>{
            if(Object.prototype.toString.call(i) === '[object Array]') {
              return i && i.length > 0 
            }else {
              return i
            }
          })
          let allArr = this.form?Object.values(this.form):[]
          this.emptyValue = !allArr.some(i=>{
            if(Object.prototype.toString.call(i) === '[object Array]') {
              return i && i.length > 0 
            }else {
              return i
            }
          })
        }
      },
      showLogin() {
        if(this.loginType === 'yxd') {
          this.$emit("update-login")
        }else {
          window.addLoginDom()
        }
      },
      formTimeSeek (startTimeStamp) {
          var nowTimeStamp = parseInt(new Date().getTime() / 1000);
          if (startTimeStamp > nowTimeStamp) {
              var seek = startTimeStamp - nowTimeStamp; // 相差时间
              var timeInterval = setInterval (function () {
                  if (seek-- <= 0) {
                      timeInterval = null;
                      window.location.href= '/form/detail.do?id='+'[[${formId}]]'
                  } else {
                      var lD = Math.floor(seek/(60*60)/24); // 相差天数
                      var lHour = Math.floor(seek/(60*60)%24); // 相差小时
                      var lMinute = Math.floor(seek/60%60); // 相差分
                      var lSecond = Math.floor(seek%60); // 相差秒
                      var lH = lHour >= 10 ?  lHour : '0'+ lHour
                      var lM = lMinute >= 10 ?  lMinute : '0'+ lMinute
                      var lS = lSecond >= 10 ?  lSecond : '0'+ lSecond
                      jQuery('#formStartTime').html('<span>'+lD+'</span><span>天</span>'+
                          '<span>'+lH+'</span><span>时</span>'+
                          '<span>'+lM+'</span><span>分</span>'+
                          '<span>'+lS+'</span><span>秒</span>')
                  }
              }, 1000);
          }
          console.log(timeInterval)
      },
      // initPageData () {
      //     let size = this.pageSize;
      //     let total = this.formData.column.length;
      //     if (this.pageSize > 0 && Math.ceil(total/size) > 1) {
      //         this.pageNum = Math.ceil(total/size)
      //         let list = []
      //         let initList = []
      //         let pageNumTotal = Math.ceil(total/size);
      //         for(; pageNumTotal > 0; pageNumTotal --) {
      //             list.push([])
      //         }

      //         this.formData.column.forEach(function(v,k) {
      //             initList.push(k)
      //             list[Math.floor(k/size)].push(k)
      //         });
      //         this.formPageData = list;
      //         this.hideFormItem(initList)
      //         this.showFormItem(this.formPageData[0])
      //     }
      // },
      initPageData () {
          let size = this.pageSize;
          let cLength = this.formData.column?this.formData.column.length:0
          let gLength = 0
          if(this.formData.group && this.formData.group.length) {
            this.formData.group.forEach(item=>{
              gLength+=item.column.length
            })
          }
          let total = cLength + gLength
          if (this.pageSize > 0 && Math.ceil(total/size) > 1) {
              this.pageNum = Math.ceil(total/size)
              let list = []
              let initList = []
              let pageNumTotal = Math.ceil(total/size);
              for(; pageNumTotal > 0; pageNumTotal --) {
                  list.push([])
              }
              if(this.formData.column && this.formData.column.length) {
                this.formData.column.forEach(item=>{
                    this.allList.push(item)
                })
              }
              if(this.formData.group && this.formData.group.length) {
                this.formData.group.forEach(item=>{
                  item.column.forEach(n=>{
                    this.allList.push(n)
                  })
                })
              }
              this.allList.forEach(function(v,k) {
                  initList.push(k)
                  list[Math.floor(k/size)].push(k)
              });
              this.formPageData = list;
              this.hideFormItem(initList)
              this.showFormItem(this.formPageData[0])
          }
      },
      hideFormItem(arr) {
          let domArr = arr;
          jQuery('#formApp .el-collapse-item__header').hide()
          domArr.forEach(function(k) {
              jQuery('#formApp .avue-form__row').eq(k).hide()
          })
      },
      showFormItem(arr) {
          let domArr = arr;
          domArr.forEach(function(k) {
              jQuery('#formApp .avue-form__row').eq(k).show()
          })
      },
      prevPage() {
          this.showFormItem(this.formPageData[this.pageIndex-2])
          this.hideFormItem(this.formPageData[this.pageIndex-1])
          this.pageIndex -= 1;
          this.checkData()
      },
      nextPage() {
          this.hideFormItem(this.formPageData[this.pageIndex-1])
          this.showFormItem(this.formPageData[this.pageIndex])
          this.pageIndex += 1;
          this.checkData()
      },
      getData() {
          if(this.scrollToCmtList()){
            if(window.ELEMENT) {
              window.ELEMENT.Message.warning(`请确保所有内容填写正确，页面将自动定位到第一个不符合要求的题目，请检查！`)
            }else {
              this.$message({
                message: `请确保所有内容填写正确，页面将自动定位到第一个不符合要求的题目，请检查！`,
                type: 'warning'
              });
            }
            return
          }
          this.sendData(this.form)
      },
      getOldData() {
          this.$refs.KFB.getData().then(res => {
              // 获取数据成功
              this.sendData(res)
          }).catch( () => {
              jQuery('#errorModel').addClass('modal-overlay-visible')
              jQuery('#errorModelContent').addClass('modal-dialog-in')
              jQuery('body').css({'overflow': 'hidden'})
          })
      },
      backHome() {
        this.$emit("up-date")
      },
      showResult() { 
        this.showTemplate = 'result'
        this.getResult()
      },
      sendData (res) {
          if(!this.verifyData()){
            return
          }
          this.submitLoading = true;
          this.endTime = new Date().getTime()
          var params = {
            id: this.encodeId,
            userId: this.userId,
            userName: this.userName,
            account: this.account,
            json: res,
            templateId: this.templateId,
            projectId: this.projectId,
            objectId: this.objectId,
            objectType: this.objectType,
            projectName: this.projectName,
            moduleName: this.moduleName,
            source: this.source,
            tenantProjectId: this.tenantProjectId,
            userAgent: this.getRandomUser(),
            timeTaken: this.endTime - this.beginTime,
            originate: this.isWx(),
            accountType: this.accountType
          }
          var that = this;
          jQuery.ajax({
              type: 'post',
              url: `${ajaxUrl}/api/material/customForm/submit`,
              //data: params,
              data: JSON.stringify(params),
              contentType:"application/json",
              dataType:'json',
              async:false,
              success: function (result) { // 请求成功执行
                  
                  that.submitLoading = false;
                  if(result.status==200){//成功
                    if(result.data.grade) {
                      if(that.loginType === 'yxd'){
                        that.$emit("update-tips", result.data.grade)
                      }else {
                        if(window.ELEMENT) {
                          window.ELEMENT.Message.success(result.data.grade)
                        }else {
                          that.$message({
                            message: result.data.grade,
                            type: 'success'
                          });
                        }
                      }
                    }
                    that.clearStorage()
                    if(result.data.createFormDataResult == 2 || result.data.createFormDataResult == 3) {
                      let msg = result.data.createFormDataResult == 2 ? '配额已满' : '显式配额规则校验未通过'
                      if(window.ELEMENT) {
                        window.ELEMENT.Message.warning(result.data.ruleCheckMsg || msg)
                      }else {
                        that.$message({
                          message: result.data.ruleCheckMsg || msg,
                          type: 'warning'
                        });
                      }
                    }else if (result.data.createFormDataResult == 4) {
                      that.showTemplate = 'error'
                      that.errorMsg = '您的问卷填写不符合相关规则，谢谢您的参与'
                      if(that.wordReactUrl && that.surveyType == 1) {
                        setTimeout(function(){
                          if(that.wordReactText) {
                            if(window.ELEMENT) {
                              window.ELEMENT.Message.success(that.wordReactText)
                            }else {
                              that.$message({
                                message: that.wordReactText,
                                type: 'success'
                              });
                            }
                          }
                          window.location.href = that.wordReactUrl
                        },2000)
                      }
                    }else {
                      if(that.wordReactUrl && that.surveyType == 1) {
                        if(that.wordReactText) {
                            if(window.ELEMENT) {
                              window.ELEMENT.Message.success(that.wordReactText)
                            }else {
                              that.$message({
                                message: that.wordReactText,
                                type: 'success'
                              });
                            }
                          }
                        window.location.href = that.wordReactUrl
                      }else {
                        // Toast('提交成功');
                        if(window.ELEMENT) {
                          window.ELEMENT.Message.success('提交成功')
                        }else {
                          that.$message({
                            message: '提交成功',
                            type: 'success'
                          });
                        }
                        that.disabledSubmit = true
                        if(that.isOpenResult==1) {
                          if(that.pollResults == 1){
                            that.isEnd = true
                            that.showResult()
                          }
                          if(that.pollResults == 2){
                            that.showResult()
                            that.isEnd = false
                          }
                        }else {
                          // that.showTemplate = 'success'
                          that.form = {}
                          that.showTemplate = 'form'
                          that.getValues()
                        }
                      }
                    }
                    that.$emit("update-submit", that.form)
                  }else {
                    that.showTemplate = 'error'
                    that.errorMsg = result.message
                  }
              }
          });

          // 提交表单埋点
          var form = {
              "userAction": "click",
              "code": "FD0-1-1-1",
              "value": "submit"
          }
          window.MsStatis.setStatisRule(form)
      },
      // 提交前校验
      verifyData() {
        let verifyBol = true
        try {
          this.option.column.forEach(item=>{
            if(item.type == 'proportion') {
              if(this.form[item.prop].length){
                let total = this.form[item.prop].reduce((prev,cur)=>prev+cur)
                if(!item.required && total == 0) {
                  return
                }
                if(total != item.total) {
                  verifyBol = false
                  if(window.ELEMENT) {
                    window.ELEMENT.Message.warning(`总比重值必须为：${item.total}，已分配比重：${total}`)
                  }else {
                    this.$message({
                      message: `总比重值必须为：${item.total}，已分配比重：${total}`,
                      type: 'warning'
                    });
                  }
                  this.scrollToCmtList(item.prop)
                  throw new Error("end");
                }
              }
            }else if(item.type == 'checkbox' || item.type == 'sort') {
              if(item.minLength && this.form[item.prop].length < item.minLength) {
                verifyBol = false
                if(window.ELEMENT) {
                  window.ELEMENT.Message.warning(`您已选择了${this.form[item.prop].length}项，本题至少要选择${item.minLength}项`)
                }else {
                  this.$message({
                    message: `您已选择了${this.form[item.prop].length}项，本题至少要选择${item.minLength}项`,
                    type: 'warning'
                  });
                }
                this.scrollToCmtList(item.prop)
                throw new Error("end");
              }
            }
             if(item.display === false && typeof item.display === 'boolean'){
                if(this.form[`$${item.prop}`]) {
                  this.form[`$${item.prop}`]=''
                }
                if(this.form[`${item.prop}`]) {
                  this.form[`${item.prop}`]=''
                }
              }
          })
        }catch(err){
          console.log(err.message)
        }
        return verifyBol
      },
      // 页面滚动到指定位置
      scrollToCmtList(val) {
        let scrollTop = false
        // 1.1 返回文档在垂直方向已滚动的像素值
        const now = window.scrollY
        // 1.2 目标位置（文章信息区域的高度）
        let firstItem = ''

        if(val) {
          firstItem = val
        }else {
          for(let i=0;i<this.requiredArr.length;i++){
            let active = this.requiredArr[i]
            let item = this.form[active]
            if(Object.prototype.toString.call(item) === '[object Array]') {
              if(!item || item.length < 1){
                firstItem = active
                break
              }else {
                continue
              }
            }else {
              if(!item) {
                firstItem = active
                break
              }else {
                continue
              }
            }
          }
        }
        if(!firstItem) {
          return scrollTop
        }
        // 自动聚焦
        if(document.querySelector(`[for=${firstItem}]`).parentNode.querySelector('input')) {
          document.querySelector(`[for=${firstItem}]`).parentNode.querySelector('input').focus()
        }else if (document.querySelector(`[for=${firstItem}]`).parentNode.querySelector('textarea')) {
          document.querySelector(`[for=${firstItem}]`).parentNode.querySelector('textarea').focus()
        }
        let dist = document.querySelector(`[for=${firstItem}]`).parentNode.parentNode.offsetTop + document.querySelector(`[for=${firstItem}]`).parentNode.offsetHeight
        // 1.3 可滚动高度 = 整个文档的高度 - 浏览器窗口的视口（viewport）高度
        const avalibleHeight =
          document.documentElement.scrollHeight - window.innerHeight
  
        // 2.1 如果【目标高度】 大于 【可滚动的高度】
        if (dist > avalibleHeight) {
          // 2.2 就把目标高度，设置为可滚动的高度
          dist = avalibleHeight
        }
  
        // 3. 动态计算出步长值
        const step = (dist - now) / 10
  
        setTimeout(() => {
          // 4.2 如果当前的滚动的距离不大于 1px，则直接滚动到目标位置，并退出递归
          if (Math.abs(step) <= 1) {
            return window.scrollTo(0, dist)
          }
          // 4.1 每隔 10ms 执行一次滚动，并递归地进行下一次的滚动
          window.scrollTo(0, now + step)
          this.scrollToCmtList(val)
        }, 10)
        scrollTop = true
        return scrollTop
      },
      // 获取调研结果
      getResult() {
          this.submitLoading = true;
          var params = {
              userId: this.userId,
              userName: this.userName,
              id: this.encodeId,
              account: this.account,
              accountType: this.accountType,
              userAgent: this.getRandomUser(),
              // projectId: this.projectId
          }
          var that = this;
          jQuery.ajax({
              type: 'post',
              url: `${ajaxUrl}/api/material/customForm/getFormResult`,
              //data: params,
              data: JSON.stringify(params),
              contentType:"application/json",
              dataType:'json',
              async:false,
              success: function (result) { // 请求成功执行
                  that.submitLoading = false;
                  if(result.status==200){//成功
                    that.resultList = result.data.content
                  }else {
                    that.showTemplate = 'error'
                    that.errorMsg = result.message
                  }
              }
          });
      },
      unexcapeHtml(content) {
        var escaper = function(match) {
          return unescapeMap[match];
        };
        // Regexes for identifying a key that needs to be escaped
        var source = '(?:' + Object.keys(unescapeMap).join('|') + ')';
        var testRegexp = RegExp(source);
        var replaceRegexp = RegExp(source, 'g');
        var string = content == null ? '' : '' + content;
        return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
      },
      // Pv计数接口
      pvCount() {
          var params = {
              id: this.encodeId,
              countType: 1
          }
          jQuery.ajax({
              type: 'post',
              url: `${ajaxUrl}/api/material/customForm/surveyViewsCount`,
              data: JSON.stringify(params),
              contentType:"application/json",
              dataType:'json',
          });
      },
      // Uv计数接口(仅在用户登录时调用)
      uvCount() {
        var params = {
            userId: this.userId,
            userName: this.userName,
            surveyId: this.encodeId,
            surveyTitle: this.templateName,
            projectId: this.projectId,
            projectName: this.projectName,
            moduleName: this.moduleName,
            originate: this.isWx(),
            accountType: this.accountType
        }
        jQuery.ajax({
            type: 'post',
            url: `${ajaxUrl}/api/material/surveyUvRecord/readSurveyRecordStatus`,
            data: JSON.stringify(params),
            contentType:"application/json",
            dataType:'json',
        });
      },
      // 生成/获取随机标识
      getRandomUser() {
        let info = `randomUser${Date.now()+Math.ceil(Math.random()*99999)}`
        if(!window.localStorage.getItem('randomUser')) {
          window.localStorage.setItem('randomUser', info)
        }
        let user = window.localStorage.getItem('randomUser')
        return user
      },
      // 临时保存
      storageSave() {
        if(!window.localStorage.getItem('storageForm')) {
          window.localStorage.setItem('beginTime', this.beginTime)
        }
        window.localStorage.setItem('encodeId', this.encodeId)
        window.localStorage.setItem('templateId', this.templateId)
        window.localStorage.setItem('storageForm', JSON.stringify(this.form))
        if(window.ELEMENT) {
          window.ELEMENT.Message.success('临时保存成功')
        }else {
          this.$message({
            message: '临时保存成功',
            type: 'success'
          });
        }
      },
      // 清除缓存时间和数据
      clearStorage() {
        window.localStorage.removeItem('storageForm')
        window.localStorage.removeItem('beginTime')
        window.localStorage.removeItem('encodeId')
        window.localStorage.removeItem('templateId')
      },
      // 获取缓存数据
      getStorage() {
        if(window.localStorage.getItem('storageForm') && this.encodeId == window.localStorage.getItem('encodeId') && this.templateId == window.localStorage.getItem('templateId')) {
          this.form = JSON.parse(window.localStorage.getItem('storageForm'))
        }
      },
      // 答题耗时
      computeTime() {
        if(window.localStorage.getItem('beginTime') && this.encodeId == window.localStorage.getItem('encodeId') && this.templateId == window.localStorage.getItem('templateId')) {
          this.beginTime = window.localStorage.getItem('beginTime')
        }else {
          this.beginTime = new Date().getTime()
        }
      },
      isWx() {
        const ua = navigator.userAgent.toLowerCase();
        if(ua.match(/MicroMessenger/i)=="micromessenger"){
          return 1
        }else{
          return 0
        }
      }
  }
}
</script>
<style scoped>
@import "https://static.medsci.cn/public-css/elementUI/2.13.2/index.css";
@import "https://static.medsci.cn/public-css/k-form-design/k-form-design.css";
@import "https://static.medsci.cn/public-css/avue/2.8.25/index.css";
@import "https://static.medsci.cn/product/medsci-site/portal/css/main-stylesheet.min.css";
@import "https://img.medsci.cn/web/prod/css/form.min.css?date=20240918";
#formApp /deep/ .el-checkbox__label {
    font-size: 16px !important;
}
#formApp /deep/ .el-input__inner{
  font-size: 16px !important;
}
#formApp /deep/ .el-radio:focus:not(.is-focus):not(:active):not(.is-disabled) .el-radio__inner {
    -webkit-box-shadow: unset; 
    box-shadow: unset; 
}
#formApp /deep/ .el-textarea__inner{
  font-size: 16px !important;
}
.avue-form /deep/ p {
  line-height: 26px;
}
#formApp /deep/ .el-radio__label {
    /* line-height: 36px; */
    font-size: 16px;
  }
.editFont{
    font-size: 26px !important;
    font-weight: bold;
    line-height: 32px !important;
    word-break: break-all;
}
.widthBtn{
    width:auto
  }
.widthBtns{
    width:100% !important
  }
.item-lable-new{
  left: 22px !important
}
.newResult{
  padding: 56px 221px 32px 221px !important;
}
.form-mid{
    padding: 56px 209px 32px 209px !important;
}
.medsci-form-header /deep/ p{
    margin-top: 16px;
    padding-bottom: 0;
    font-size: 14px !important;
    color: #666666;
}
.medsci-form-header /deep/ .wscnph {
  width: 700px;
  height: 119px
}
.medsci-form-header h2{
  font-size: 18px;
  color: #333333;
  margin-bottom: 0;
  line-height: 1;
}
.medsci-form-content /deep/ .avue-form__row{
  padding: 0 !important; 
}
.medsci-form-content{
  padding-top:16px; 
}
[v-cloak]{
  display: none;
}
.wrapper {
  position: relative;
}
.progress-box {
  position: fixed;
  top: 50%;
  transform: translateY(-50%);
  right: 20px;
  width: 40px;
  height: 160px;
  box-shadow: 4px 4px 4px 0 #ccc;
  background: #fff;
  z-index: 999;
  font-size:12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #666;
  justify-content: space-around;
}
.progres-percent {
  color: #000;
  font-weight: bold;
}
.progress-line {
  width: 10px;
  height: 100px;
  background: #EEEBEB;
}
.progress-line-inner {
  width: 4px;
  background: #53a4f4;
  margin: 0 auto;
}
.el-cascader-menu {
  overflow: hidden !important;
  min-width: 180px !important;
  height: auto !important;
  padding: 0 !important;
}
.el-cascader-menu__wrap {
  height: 204px !important;
}
.flex {
  display: flex;
  flex-direction: row;
}
.form-page-wrapper /deep/ button {
  margin: 0 10px;
}
#formApp {
  min-height: 0;
}
#formApp .form-tip img {
  width: 80px !important;
}
#formApp .form-tip p {
  font-size: 18px !important;
  margin-top: 10px !important;
}
.el-form-item {
  background: red !important;
}

#formApp /deep/ .avue-form__group .el-form-item__label{
  color: #333333;
  font-size: 16px;
  float: none;
  width: 100% !important;
  line-height: 24px;
  font-weight: 500;
}
#formApp /deep/ .avue-form__group .el-form-item__content {
  margin-left: 0 !important;
}
#formResult{

}
#formResult .result-grey {
  font-size: 14px;
  color: #999999;
  line-height: 1;
  margin-top: 10px;
}
.form-result .result-grey {
  font-size: 14px;
  color: #999999;
  line-height: 1;
  margin-top: 10px;
  margin-bottom: 2px;
}
#formResult .res-item{
    margin-bottom: 18px;
  }
#formResult .res-item .item-list-pre .pre-bottom {
  position: relative;
  height: 36px;
  border-radius: 28px;
  background: #F6F6F6;
}

#formResult .res-item .item-list-pre .pre-bottom .percent-font{
  position: absolute;
  left: 24px;
  line-height: 36px;
  margin: 0;
  font-size: 16px;
  white-space: nowrap;
}

#formResult .res-item .item-list-pre .pre-bottom .item-list-label {
  position: absolute;
  margin: 0;
  left: 80px;
  top: 0;
  line-height: 36px;
  font-size: 16px;
  white-space: nowrap;
}
#formResult .res-item .item-list-pre .current {
    background: #EFF7FE;
}
#formResult .res-item .item-list-pre .current .percent-font{
  color: #2F92EE;
  font-weight: 500;
}
#formResult .res-item .item-list-pre .current .item-list-label{
  color: #2F92EE;
  font-weight: 500;
}
#formResult /deep/ .avue-form, #formApp /deep/ .avue-form{
    margin: 0 auto;
    box-sizing: border-box;
    padding: 0 !important;
}
#formApp /deep/ .el-form-item__content{
    margin-top: 10px ;
}
 #formResult .res-item .item-label {
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 8px;
    color:#333333

  }
@media screen and (max-width: 768px) {
  #formApp /deep/ .el-form-item__content{
  margin-top: 0 !important;
}
  .editFont{
    font-weight: bold !important;
    font-size: 20px !important;
    line-height: 24px !important;
}
  #formResult .res-item .item-list-pre .current {
    background: #EFF7FE;
  }
  #formResult .res-item .item-list-pre .current .percent-font{
    color: #2F92EE !important;
  }
  #formResult .res-item .item-list-pre .current .item-list-label{
    color: #2F92EE !important;
  }
  .lastPagee{
    margin-bottom: 10px !important;
  }
  .widthBtn{
    width:100%
  }
  .newResult{
    padding: 30px 18px 24px!important;
}
  .form-page-wrapper /deep/ button {
    margin: 0;
    width: 100%;
  }
  .form-mid{
    padding: 30px 18px 24px !important;
  }
  .medsci-form-header /deep/ p{
    font-size: 14px !important;
    color: #666666 !important;
    display: block !important;
    /* margin-top: 16px; */
    padding-bottom: 0;
    margin-bottom: 15px;
    margin-top: 20px;
  }
.medsci-form-header /deep/ .wscnph {
  width: 345px;
  height: auto
}
  #formResult .list-options{
  padding-bottom:15px !important;
  padding-top: 0 !important;
}
  .wrapper {
    max-width: 100% !important;
  }
  .form-mid,.form-result{
    border-radius: 0;
  }
  #formApp {
    overflow: hidden;
  }

  #formApp /deep/ .el-collapse-item__wrap {
    overflow: inherit;
  }
  #formApp /deep/ .avue-form__group .el-form-item__label{
    float: none;
    display: block;
    width: 100vw !important;
    margin-bottom: 8px;
    background: #FAFAFA;
    margin-left: -28px;
    padding: 5px 30px;
  }
  #formApp /deep/ .avue-form__group .el-form-item__content {
    margin-left: 0 !important;
  }
  #formApp /deep/ .avue-group .el-collapse-item__header {
    margin-bottom: 0;
  }
  #formApp /deep/ .el-radio-group {
    max-width: 100%;
  }
  #formApp /deep/ .el-radio {
    margin-bottom: 6px;
    text-align: justify;
    white-space: normal;
  }
  #formApp /deep/ .el-radio__label {
    line-height: 36px;
    /* font-size: 15px; */
  }
  #formApp /deep/ .el-form-item .el-form-item__content > div > div > div:not(.grey,.el-input-group__append) {
    display: flex;
    flex-direction: column;
  }
  #formApp /deep/ .el-checkbox-group .el-checkbox__label {
    width: 100%;
    white-space: normal;
    vertical-align: text-top;
    margin-top: 1px;
  }
  #formApp /deep/ .el-form-item__error{
    position: static;
  }
  .result-grey {
    font-size: 13px;
    color: #999999;
    margin: 5px 0 0
  }
  #formResult .res-item .item-label {
    font-size: 16px;
    font-weight: 500;
  }
  #formResult .res-item .item-list-label {
    font-size: 14px;
  }
  #formResult .res-item .item-list-pre .pre-bottom {
    height: 36px;
    border-radius: 28px;
  }

  #formResult .res-item .item-list-pre .pre-bottom .percent-font{
    left: 12px;
    line-height: 36px;
    font-size: 15px;
    color:#333333
  }

  #formResult .res-item .item-list-pre .pre-bottom .item-list-label {
    left: 57px;
    font-size: 15px;
    color:#333333;
    top: 0;
    line-height: 36px;
  }
}
</style>
<style>
@media (min-width: 769px){
  #formResult .list-options{
  padding-bottom:8px !important;
  padding-top: 0 !important;
}
  /* 竖向排列 */
  #formApp .el-form-item .el-form-item__content > div > div > div:not(.grey,.el-input-group__append) {
    display: flex;
    flex-direction: column;
  }
  #formApp .el-form-item .el-form-item__content > div > div > div > label {
    height: 36px;
    line-height: 36px;
    font-size: 16px;
    color: 3333333;
  }
    /* #formApp .el-radio__label ,.el-checkbox__label{
      font-size: 16px;
  } */
   /* 横向自适应 */
  .el-form-item.row1 .el-form-item__content > div > div > div {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }
  .el-form-item.row1 .el-form-item__content > div > div > div > label {
    height: 32px;
    line-height: 32px;
  }
  /* 横向2列 */
  #formApp .el-form-item.row2 .el-form-item__content > div > div > div {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }
  #formApp .el-form-item.row2 .el-form-item__content > div > div > div > label {
    height: 32px;
    line-height: 32px;
    margin-right: 0;
    width: 50%;
  }
  /* 横向3列 */
  #formApp .el-form-item.row3 .el-form-item__content > div > div > div {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }
  #formApp .el-form-item.row3 .el-form-item__content > div > div > div > label {
    height: 32px;
    line-height: 32px;
    margin-right: 0;
    width: 33%;
  }
  /* 横向4列 */
  #formApp .el-form-item.row4 .el-form-item__content > div > div > div {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }
  #formApp .el-form-item.row4 .el-form-item__content > div > div > div > label {
    height: 32px;
    line-height: 32px;
    margin-right: 0;
    width: 25%;
  }
  /* 横向5列 */
  #formApp .el-form-item.row5 .el-form-item__content > div > div > div {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }
  #formApp .el-form-item.row5 .el-form-item__content > div > div > div > label {
    height: 32px;
    line-height: 32px;
    margin-right: 0;
    width: 20%;
  }
  /* 横向6列 */
  #formApp .el-form-item.row6 .el-form-item__content > div > div > div {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }
  #formApp .el-form-item.row6 .el-form-item__content > div > div > div > label {
    height: 32px;
    line-height: 32px;
    margin-right: 0;
    width: 16.6%;
  }
  /* 横向7列 */
  #formApp .el-form-item.row7 .el-form-item__content > div > div > div {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }
  #formApp .el-form-item.row7 .el-form-item__content > div > div > div > label {
    height: 32px;
    line-height: 32px;
    margin-right: 0;
    width: 14.28%;
  }
  /* 横向8列 */
  #formApp .el-form-item.row8 .el-form-item__content > div > div > div {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }
  #formApp .el-form-item.row8 .el-form-item__content > div > div > div > label {
    height: 32px;
    line-height: 32px;
    margin-right: 0;
    width: 12.5%;
  }
  /* 横向9列 */
  #formApp .el-form-item.row9 .el-form-item__content > div > div > div {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }
  #formApp .el-form-item.row9 .el-form-item__content > div > div > div > label {
    height: 32px;
    line-height: 32px;
    margin-right: 0;
    width: 11.11%;
  }
  /* 横向10列 */
  #formApp .el-form-item.row10 .el-form-item__content > div > div > div {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }
  #formApp .el-form-item.row10 .el-form-item__content > div > div > div > label {
    height: 32px;
    line-height: 32px;
    margin-right: 0;
    width: 10%;
  }
}
</style>